import {
  Instagram,
  Mail,
  MessageCircle,
  MessageCircleMore,
  MessageSquare,
  Slack,
  Smartphone,
} from "lucide-react";
import type { LucideIcon } from "lucide-react";
import { CHANNELS } from "@/lib/channels";
import type { Channel } from "@/lib/types";

export interface ChannelBadgeProps {
  channel: Channel;
  size?: number;
}

const CHANNEL_ICONS: Record<Channel, LucideIcon> = {
  feedback: MessageSquare,
  chat: MessageCircle,
  email: Mail,
  whatsapp: MessageCircleMore,
  instagram: Instagram,
  sms: Smartphone,
  slack: Slack,
};

export function ChannelBadge({ channel, size = 14 }: ChannelBadgeProps) {
  const Icon = CHANNEL_ICONS[channel];
  const meta = CHANNELS[channel];
  return (
    <span
      className="inline-flex items-center justify-center rounded-full text-white"
      style={{ width: size, height: size, backgroundColor: meta.color }}
      title={meta.label}
      aria-label={meta.label}
    >
      <Icon size={Math.round(size * 0.62)} strokeWidth={2} />
    </span>
  );
}
